import type { DateRepresentation } from '@core/core/utils'
import { relativeDateFormatter } from '@core/core/utils'
import { useEffect, useReducer } from 'react'

const MINUTE_MS = 60 * 1000

export const useRelativeDate = (date: DateRepresentation | undefined) => {
  const [relativeDate, tick] = useReducer(
    () => relativeDateFormatter.relativeDate(date),
    date,
    relativeDateFormatter.relativeDate,
  )

  useEffect(() => {
    const interval = setInterval(tick, MINUTE_MS)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return relativeDate
}
